module.exports = __webpack_public_path__ + "static/ogbeide-fc331bdba0d155832aaf11f059bb6a1f.png";